var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"title":"Renvoyer le mail de création de compte","icon-left":"email-outline","loading":_vm.loading},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }